

















import Vue, { PropType } from 'vue';
import { BasePacket, utils as PacketUtils } from '@/models/packet';
import { IconData } from '@/icons';

import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon
  },

  props: {
    packet: Object as PropType<BasePacket>
  },

  computed: {
    icons(): IconData[] {
      return PacketUtils.getPacketIcons(this.packet);
    }
  }
});
